// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ButtonSearchFilter {
  font-size: 20px;
  margin-top: 24px;
}
.ButtonSearchFilter button {
  font-size: 20px;
  padding: 5px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/pages/SearchTerritoriesPage/components/WinninTopicsTab/components/ButtonSearchVideos/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AACJ","sourcesContent":[".ButtonSearchFilter {\n  font-size: 20px;\n  margin-top: 24px;\n\n  button {\n    font-size: 20px;\n    padding: 5px;\n    font-weight: 700;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
